import { useEffect, type ReactElement } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
import { useTheme } from './hooks/useTheme';
import { AdminPage } from './pages/AdminPage';
import { ArticlePage } from './pages/ArticlePage';
import { FeedPage } from './pages/FeedPage';
import { FavoritesPage } from './pages/FavoritesPage';
import { SettingsPage } from './pages/SettingsPage';

function NotFound(): ReactElement {
  return <div className="surface p-10 text-center"><p className="eyebrow">404</p><h1 className="mt-2 font-display text-3xl font-semibold tracking-[-0.06em] text-ink">Questo segnale non esiste.</h1><a href="/" className="mt-5 inline-flex rounded-xl bg-accent px-4 py-2.5 text-sm font-semibold text-white">Torna al radar</a></div>;
}

function SeoController(): null {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith('/article/')) return;
    const titles: Record<string, string> = {
      '/': 'AI Radar — Il segnale prima del rumore',
      '/latest': 'Ultime notizie — AI Radar',
      '/top-stories': 'Top stories — AI Radar',
      '/search': 'Ricerca — AI Radar',
      '/open-source': 'Open Source — AI Radar',
      '/research': 'Research — AI Radar',
      '/companies': 'Companies — AI Radar',
      '/favorites': 'Preferiti — AI Radar',
      '/settings': 'Impostazioni — AI Radar',
      '/admin': 'Admin — AI Radar'
    };
    document.title = titles[location.pathname] ?? 'AI Radar';
    document.querySelector('meta[name="description"]')?.setAttribute('content', 'Tutto quello che succede nell’AI, in un unico posto.');
  }, [location.pathname]);
  return null;
}

export function App(): ReactElement {
  const [theme, setTheme] = useTheme();
  return <BrowserRouter><SeoController /><Layout theme={theme} onThemeChange={setTheme}><Routes><Route path="/" element={<FeedPage />} /><Route path="/latest" element={<FeedPage />} /><Route path="/top-stories" element={<FeedPage />} /><Route path="/open-source" element={<FeedPage />} /><Route path="/research" element={<FeedPage />} /><Route path="/companies" element={<FeedPage />} /><Route path="/search" element={<FeedPage />} /><Route path="/favorites" element={<FavoritesPage />} /><Route path="/settings" element={<SettingsPage theme={theme} onThemeChange={setTheme} />} /><Route path="/admin" element={<AdminPage />} /><Route path="/article/:id" element={<ArticlePage />} /><Route path="*" element={<NotFound />} /></Routes></Layout></BrowserRouter>;
}
